import { StatusType, CardBrandType } from "../types/statistics.types";

export const PUBLIC_PATH_PREFIXES = ['/3ds'];

export const isPublicPath = (pathname: string): boolean =>
    PUBLIC_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));

export const getColorByStatusType = (type: StatusType): string => {
    const statusData: Partial<Record<StatusType, string>> = {
        APPROVED: '#00B69B',
        CHARGEBACK: '#32ADE6',
        REFUNDED: '#6A5CA8',
        RDR: '#32ADE6',
        DECLINED: '#FF9500',
        PENDING: '#5C4033',
        ERROR: '#EF1E1A',
    };

    return statusData[type] || '#000000';
};


const gradientColorsByStatus: Record<StatusType, [string, string]> = {
    APPROVED: ['rgba(0, 182, 155, 1)', 'rgba(0, 80, 68, 0.5)'],
    CHARGEBACK: ['rgba(50, 173, 230, 1)', 'rgba(25, 87, 115, 0.5)'],
    REFUNDED: ['rgba(106, 92, 168, 1)', 'rgba(53, 46, 84, 0.5)'],
    RDR: ['rgba(50, 173, 230, 1)', 'rgba(25, 87, 115, 0.5)'],
    DECLINED: ['rgba(255, 149, 0, 1)', 'rgba(128, 74, 0, 0.5)'],
    PENDING: ['rgba(92, 64, 51, 1)', 'rgba(46, 32, 26, 0.5)'],
    ERROR: ['rgba(134, 17, 17, 1)', 'rgba(236, 34, 31, 0.5)'],

};

export const getGradientColorsByStatus = (status: StatusType): [string, string] => {
    return gradientColorsByStatus[status] || ['rgba(0,0,0,0.5)', 'rgba(0,0,0,0)'];
}

export const transformTransactionsToChartLineData = (
    datasets: { label: string; data: { date: string; transactionNo: number }[] }[]
) => {
    return datasets.map(ds => ({
        label: ds.label,
        values: ds.data,
        colors: getGradientColorsByStatus(ds.label as StatusType),
    }));
};


export const getGradientByStatusType = (type: StatusType): string => {
    const statusData: Partial<Record<StatusType, string>> = {
        APPROVED: '#00B69B',
        CHARGEBACK: '#32ADE6',
        REFUNDED: '#6A5CA8',
        RDR: '#32ADE6',
        DECLINED: '#FF9500',
        PENDING: '#5C4033',
        ERROR: '#EF1E1A',
    };

    return statusData[type] || '#000000';
};

export const getColorByNextStatusType = (type: any): string => {
    const statusData: any = {
        APPROVED: '#00B69B',
        CHARGEBACK: '#32ADE6',
        REFUNDED: '#6A5CA8',
        RDR: '#32ADE6',
        DECLINED: '#FF9500',
        PENDING: '#5C4033',
        ERROR: '#EF1E1A',
    };

    return statusData[type] || '#000000';
};

export const getColorByCardBrandType = (type: CardBrandType): string => {
    const cardBrandData: Record<CardBrandType, string> = {
        Visa: '#FCBE2D',
        MasterCard: '#FF9500',
        "American Express": '#32ADE6',
    };

    return cardBrandData[type] || '#000000';
};


const gradientColorsByCardBrand: Record<CardBrandType, [string, string]> = {
  Visa: ['rgba(252, 190, 45, 0.5) ', 'rgba(150, 113, 27, 0)'],
  MasterCard: ['rgba(255, 149, 0, 1)', 'rgba(153, 89, 0, 0)'],
  'American Express': [' rgba(50,173,230,1)', 'rgba(255, 255, 255, 0)'],
};


export const getGradientColorsByCardBrand = (
    brand: CardBrandType
): [string, string] => {
    return gradientColorsByCardBrand[brand] || ['#000000', '#000000'];
};

export const transformCardBrandToChartLineData = (
  datasets: { label: string; data: { date: string; transactionNo: number }[] }[]
) => {
  return datasets.map(ds => ({
    label: ds.label,
    values: ds.data,
    colors: getGradientColorsByCardBrand(ds.label as CardBrandType),
  }));
};

export const transformToChartLineData = (
  datasets: { label: string; data: { date: string; transactionNo: number }[] }[]
) => {
  return datasets.map((ds, index ) => ({
    label: ds.label,
    values: ds.data,
    colors: getRandomGradientColorsByIndex(index),
  }));
};


export const getRandomColor = (index: number): string => {
    return colorsArray[index % colorsArray.length];
};

const colorsArray = [
    '#00B69B', // Teal
    '#32ADE6', // Light Blue
    '#6A5CA8', // Purple
    '#FF9500', // Orange
    '#EF1E1A', // Red
    '#FFD700', // Gold
    '#A3CB38', // Lime Green
    '#009688', // Turquoise
    '#9C27B0', // Deep Purple
    '#795548', // Brown
    '#8E44AD', // Violet
    '#34495E', // Dark Blue Gray
    '#F1C40F', // Yellow
    '#E67E22', // Pumpkin
    '#2980B9', // Strong Blue
    '#27AE60', // Forest Green
    '#C0392B', // Strong Red
    '#2ECC71', // Emerald
    '#E74C3C', // Coral
    '#1ABC9C', // Strong Teal
    '#2C3E50'  // Midnight Blue
];

const gradientColorsArray: [string, string][] = colorsArray.map(hex => {
    const darken = (hex: string, amount = 40) => {
        let col = hex.replace('#', '');
        const r = Math.max(0, parseInt(col.substring(0, 2), 16) - amount);
        const g = Math.max(0, parseInt(col.substring(2, 4), 16) - amount);
        const b = Math.max(0, parseInt(col.substring(4, 6), 16) - amount);
        return `rgba(${r}, ${g}, ${b}, 0.5)`;
    };

    return [hex, darken(hex)];
});

export const getRandomGradientColorsByIndex = (index: number): [string, string] => {
    return gradientColorsArray[index % gradientColorsArray.length];
};


